import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge only knows Tailwind's default scales. Register the custom tokens from the `@theme inline` block in
 * src/styles.css so that, for example, `text-tiny` counts as a font size (not a text color) and a later `px-3` replaces
 * an earlier `px-4`. Keep these lists in sync with src/styles.css.
 */
const twMerge = extendTailwindMerge({
	extend: {
		theme: {
			text: ["micro", "label", "tiny", "caption", "ctl", "ctl-lg", "body", "figure", "title", "display"],
			radius: ["ctl", "field", "btn", "tile", "card", "pill"],
			shadow: ["card", "cta", "drawer", "toast"],
			tracking: ["body", "title", "display", "caps"],
			spacing: ["rail", "topbar", "gutter"],
			ease: ["ui"],
			animate: ["fade-in", "breathe", "shimmer", "progress"],
		},
	},
});

/** Joins class names, skipping falsy values, and resolves Tailwind conflicts so the last class wins. */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
